var angular = require('angular');
angular.module('promemoria')
  .component('auiExpand', {  
    template: require('./expand.html'),
    bindings: {
      meta: '<'
    },
    controller: function () {
      var ctrl = this; 
      ctrl.expandClose = true
    }  
  })



// WEBPACK FOOTER //
// ./src/js/components/expand/expand.js